import React, { useState, useEffect } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { AddFaq, UpdateFaqs } from "Services/ServiceRequest";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import ReactLoading from "react-loading";
function AddUser({
    setModal,
    showModal,
    GetRequests,
    edit,
    setEdit,
    setSubLoad,
}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const closeModal = () => {
        if (!loading) {
            setModal(false);
            reset({ question: "", answer: "" });
            setError("");
            setEdit(null);
        }
    };
    useEffect(() => {
        if (edit) {
            reset(edit);
        }
        /* if (localStorage.getItem("prefillData")) {
        } */
    }, [edit]);
    const onSubmit = async (data) => {
        setLoading(true);
        setSubLoad(true);

        if (edit) {
            let body = { ...data };
            try {
                const response = await UpdateFaqs(edit?.FAQId, {
                    ...body,
                });
                setLoading(false);
                if (response?.data?.Status === 1) {
                    GetRequests();
                    setEdit(null);
                    reset({ question: "", answer: "" });
                    Swal.fire({
                        title: "Success",
                        text:
                            response?.data?.Message || "FAQ Update Successfull",
                        icon: "success",
                    });
                    closeModal();
                } else {
                    setSubLoad(false);
                    setError(
                        error?.response?.data?.error?.name ||
                            response?.data?.Message ||
                            "Something went wrong please try again"
                    );
                }
            } catch (err) {
                setLoading(false);
                setSubLoad(false);
                setError(
                    err?.response?.data?.Message ||
                        "Something went wrong please try again"
                );
            }
        } else {
            try {
                const response = await AddFaq({
                    ...data,
                });
                setLoading(false);
                if (response?.data?.Status === 1) {
                    GetRequests();
                    setEdit(null);
                    reset({ question: "", answer: "" });
                    Swal.fire({
                        title: "Success",
                        text:
                            response?.data?.Message || "FAQ Added Successfull",
                        icon: "success",
                    });
                    closeModal();
                } else {
                    setSubLoad(false);
                    setError(
                        error?.response?.data?.error?.name ||
                            response?.data?.Message ||
                            "Something went wrong please try again"
                    );
                }
            } catch (err) {
                setLoading(false);
                setSubLoad(false);
                setError(
                    err?.response?.data?.Message ||
                        "Something went wrong please try again"
                );
            }
        }
    };

    return (
        <Modal
            Modal
            isOpen={showModal}
            contentLabel="Modal"
            className={"modal"}
            onRequestClose={closeModal}
            overlayClassName={"overlay"}>
            <div className="form_wrapper_Modal">
                <header>
                    <h3>{edit ? "Update" : "Add"} FAQ</h3>
                    <button onClick={closeModal} disabled={loading}>
                        <IoCloseCircleOutline />
                    </button>
                </header>
                <form
                    form
                    onSubmit={handleSubmit(onSubmit)}
                    className="Add_form Add_form_faq">
                    <div className="Form_Control">
                        <label htmlFor="">Question</label>
                        <input
                            className={errors.question ? "error" : ""}
                            {...register("question", { required: true })}
                        />
                        {errors.question && <span>This field is required</span>}
                    </div>
                    <div className="Form_Control">
                        <label htmlFor="">Answer</label>
                        <textarea
                            rows={5}
                            className={errors.answer ? "error" : ""}
                            {...register("answer", { required: true })}
                        />
                        {errors.answer && <span>This field is required</span>}
                    </div>

                    {error.length > 0 && (
                        <p
                            className="full-width"
                            style={{ color: "red", fontSize: "0.9rem" }}>
                            {error}
                        </p>
                    )}
                    <div className="add_form_btns full-width">
                        <button type="submit" disabled={loading}>
                            {loading ? (
                                <ReactLoading
                                    color="blue"
                                    type="spokes"
                                    height={20}
                                    width={20}
                                />
                            ) : edit ? (
                                "Update FAQ"
                            ) : (
                                "Add FAQ"
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            disabled={loading}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

export default AddUser;
